import { useSelector } from 'react-redux'
import { getUserDefaultPaymentInfoSelector } from 'spypoint/src/user-module/payment-methods/core/userPaymentMethods.selectors'
import useLoad from 'shared-module/loading/useLoad'
import useReload from 'shared-module/loading/useReload'
import useUserPaymentMethodsActions from 'spypoint/src/user-module/payment-methods/core/useUserPaymentMethods.actions'

export const useUserDefaultPaymentInfo = () => useSelector(getUserDefaultPaymentInfoSelector)
export const useLoadUserDefaultPaymentInfo = () => useLoad('user-payment-methods', useUserDefaultPaymentInfo(), useUserPaymentMethodsActions().get)
export const useReloadUserDefaultPaymentInfo = () => useReload(useUserDefaultPaymentInfo(), useUserPaymentMethodsActions().get)
